import { Component, ChangeDetectionStrategy } from '@angular/core';
import { MatDialogRef, MatDialogModule } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';
import { TranslateModule } from '@ngx-translate/core';

@Component({
    selector: 'app-idle-warning-dialog',
    templateUrl: './idle-warning-dialog.component.html',
    styleUrls: ['./idle-warning-dialog.component.css'],
    changeDetection: ChangeDetectionStrategy.Default,
    imports: [MatDialogModule, MatButtonModule, MatIconModule, TranslateModule]
})
export class IdleWarningDialogComponent {
  constructor(
    public dialogRef: MatDialogRef<IdleWarningDialogComponent>
  ) { }

  onContinue(): void {
    this.dialogRef.close('continue');
  }
}
